<template>
    <HeaderContent title="Directory Activity"/>
    <ActionContent ctaText="Activity" :filterDate="false" @action="modal = !modal " />
    <ActivityForm :modal="modal" @update:modal="modal = $event"></ActivityForm>
	<DataTable 
		:data="data" 
		:header="headers" 
		:currentPage="currentPage" 
		:custom-actions="customActions"
	/>
    
</template>



<script>
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import ActivityForm from './ActivityForm.vue';
import DataTable from '@/components/DataTable.vue';
import activityDummy from '@/dummy-data/activity.js'
import { ref } from 'vue';
    export default{
        name : 'ActivityIndex',
        components : {
            HeaderContent,
            ActionContent,
            ActivityForm,
            DataTable
        },
        setup(){
            const modal = ref(false)
            const data = activityDummy
            const headers = ref([
                {key : 'id',label: 'ID',sortable: true,},
                {key : 'destination_code', label : 'Destination Code',sortable: true, },
                {key : 'activity_name', label : 'Activity Name',sortable: true, },
                {key : 'price', label : 'Price',sortable: true, },
                {key : 'action', label : 'Action' },  
            ])
            const customActions = ref([
                {
                    label: 'Edit',
                    variant: 'success',
                    icon: 'fas fa-edit',
                    action: (item) => {
                    console.log('Edit action clicked for:', item);
                    }
                },
                {
                    label: 'Delete',
                    variant: 'danger',
                    icon: 'fas fa-trash',
                    action: (item) => {
                    console.log('Delete action clicked for:', item);
                    }
                },
                
            ]);
            return {
                modal,
                data,
                headers,
                customActions
            }
        }
    }
</script>


